import { render, staticRenderFns } from "./ModalImpugnacao.vue?vue&type=template&id=04047fcf&scoped=true"
import script from "./ModalImpugnacao.vue?vue&type=script&lang=js"
export * from "./ModalImpugnacao.vue?vue&type=script&lang=js"
import style0 from "./ModalImpugnacao.vue?vue&type=style&index=0&id=04047fcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04047fcf",
  null
  
)

export default component.exports